import mitt, { Emitter } from '@/utils/mitt'

const emitter: Emitter = mitt()

export default emitter
